import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AuditDTO } from "../models/AuditLog/AuditDTO";
import { CheckIfOwnerRequestDTO } from "../models/Equipment/CheckIfOwnerRequestDTO";
import { CountersFromEquipmentRequestDTO } from "../models/Equipment/CountersFromEquipmentRequestDTO";
import { CreateEquipmentDTO } from "../models/Equipment/CreateEquipmentDTO";
import { EditEquipmentDTO } from "../models/Equipment/EditEquipmentDTO";
import { EditSoftwareDTO } from "../models/Equipment/EditSoftwareDTO";
import { EquipmentDTO } from "../models/Equipment/EquipmentDTO";
import { EquipmentRecallDTO } from "../models/Equipment/EquipmentRecallDTO";
import { EquipmentWarrantyDTO } from "../models/Equipment/EquipmentWarrantyDTO";
import { PaginatedEquipmentCounterDTO } from "../models/Equipment/PaginatedEquipmentCounterDTO";
import { ProjectsFromEquipmentRequestDTO } from "../models/Equipment/ProjectsFromEquipmentRequestDTO";
import { ProjectsFromEquipmentResponseDTO } from "../models/Equipment/ProjectsFromEquipmentResponseDTO";
import { SearchByCarPlate } from "../models/Equipment/SearchByCarPlate";
import { SearchByNSerie } from "../models/Equipment/SearchByNSerie";
import { TimeHistoryFromEquipmentRequestDTO } from "../models/Equipment/TimeHistoryFromEquipmentRequestDTO";
import { TimeHistoryFromEquipmentResponseDTO } from "../models/Equipment/TimeHistoryFromEquipmentResponseDTO";
import { UpdateEquipmentDTO } from "../models/Equipment/UpdateEquipmentDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class EquipmentService {

    async GetByCarPlate(
        searchParams: SearchByCarPlate,
    ): Promise<MessagingHelper<EquipmentDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/getEquipmentByCarPlate`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação dos equipamentos",
                null
            );
        }
    }
    async CheckIfClientIsEquipmentOwner(data: CheckIfOwnerRequestDTO)
        : Promise<MessagingHelper<boolean>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/CheckIfOwner?id=${data.equipmentErpId}`,
                {
                    ...data
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        }
        catch (error) {
            return new MessagingHelper<boolean>(
                false,
                "Erro ao verificar se o cliente é proprietário do equipamento",
                false);
        }
    }

    async GetByNSerie(
        searchParams: SearchByNSerie,
    ): Promise<MessagingHelper<EquipmentDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetBySerialNumber`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação dos equipamentos",
                null
            );
        }
    }

    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<EquipmentDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<EquipmentDTO>(
                false,
                "Erro ao obter a informação dos equipamentos",
                "",
                [],
                0,
            );
        }
    }

    async GetByIdErp(idErp: string): Promise<MessagingHelper<EquipmentDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/GetByIdErp/${idErp}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação do equipamento",
                null
            );
        }
    }

    async GetById(id: number): Promise<MessagingHelper<EditEquipmentDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/GetById/${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );

            return response.data;

        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter equipamento",
                null
            );
        }
    }

    async Create(createEquipment: CreateEquipmentDTO): Promise<MessagingHelper<string>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/Create`,
                {
                    ...createEquipment
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + APIService.GetToken()
                    }
                }
            )

            return response.data;
        }
        catch (error) {
            return new MessagingHelper<string>(false, "Erro ao ligar ao servidor para criar o equipamento", "");
        };
    }

    async Edit(equipmentUpdate: UpdateEquipmentDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/Edit`,
                { ...equipmentUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar o equipamento",
                null,
            );
        }
    }

    async Delete(id: string | undefined): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().delete(
                `${APIService.GetURL()}/Equipment/Delete/${id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + APIService.GetToken(),
                },
            },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper(
                false,
                "Erro ao ligar ao servidor para eliminar o equipamento",
                null,
            );
        }
    }

    async GetProjectsFromEquipment(
        search: ProjectsFromEquipmentRequestDTO
    ): Promise<PaginatedList<ProjectsFromEquipmentResponseDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetProjectsFromEquipment`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ProjectsFromEquipmentResponseDTO>(
                false,
                "Erro ao ligar ao servidor para obter as obras do equipamento",
                "",
                [],
                0
            );
        }
    }

    async GetTimeHistoryFromEquipment(
        search: TimeHistoryFromEquipmentRequestDTO
    ): Promise<PaginatedList<TimeHistoryFromEquipmentResponseDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetTimeHistoryFromEquipment`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<TimeHistoryFromEquipmentResponseDTO>(
                false,
                "Erro ao ligar ao servidor para obter os contadores do equipamento",
                "",
                [],
                0
            );
        }
    }

    async DownloadDataSheet(id: number | null): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/DownloadDataSheet/${id}`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper(
                false,
                "Erro ao ligar ao servidor para obter a ficha técnica do equipamento",
                null,
            );
        }
    }

    async AddDataSheet(
        dataSheet: File,
        equipmentId: number
    ): Promise<MessagingHelper<null>> {
        try {
            const formData = new FormData();
            formData.append("DataSheet", dataSheet, dataSheet.name);

            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/${equipmentId}/AddDataSheet`,
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para adicionar a ficha técnica do equipamento",
                null
            );
        }
    }

    async GetDistinctBrands(brand: string | null): Promise<MessagingHelper<string[]>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/GetDistinctBrands`,
                {
                    params: { brand },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return new MessagingHelper<string[]>(
                false,
                "Erro ao ligar ao servidor para obter a lista de marcas.",
                []
            );
        }
    }

    async GetDistinctModels(model: string | null): Promise<MessagingHelper<string[]>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/GetDistinctModels`,
                {
                    params: { model },
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return new MessagingHelper<string[]>(
                false,
                "Erro ao ligar ao servidor para obter a lista de modelos.",
                []
            );
        }
    }

    async EditSoftware(softwareToUpdate: EditSoftwareDTO): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/EditSoftware`,
                { ...softwareToUpdate },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para atualizar o software",
                null,
            );
        }
    }

    async GetCountersFromEquipment(
        request: CountersFromEquipmentRequestDTO
    ): Promise<PaginatedList<PaginatedEquipmentCounterDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetCounters`,
                {
                    ...request
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<PaginatedEquipmentCounterDTO>(
                false,
                "Erro ao obter os contadores do equipamento",
                "",
                [],
                0
            );
        }
    }

    async GetAuditByTableNameAndId(id: string | null, sortingParameters: Parameter[], currentPage: number, pageSize: number): Promise<PaginatedList<AuditDTO>> {
        try {
            const response = await APIService.Axios().post(
                `${APIService.GetURL()}/Equipment/GetAuditLogByEquipmentId?id=${id}`,
                {
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );

            return response.data;
        } catch (error) {
            return new PaginatedList<AuditDTO>(
                false,
                "Erro ao ligar ao servidor para obter os logs de auditoria do equipamento",
                "",
                [],
                0
            );
        }
    }

    async WarrantyDetailsFromEquipment(id: number): Promise<MessagingHelper<EquipmentWarrantyDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/WarrantyDetailsFromEquipment?id=${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );

            return response.data;

        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter a garantia do equipamento",
                null
            );
        }
    }

    async RecallDetailsFromEquipment(id: number): Promise<MessagingHelper<EquipmentRecallDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/Equipment/RecallDetailsFromEquipment?id=${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );

            return response.data;

        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter a campanha do equipamento",
                null
            );
        }
    }
}